import {sliderOpt} from 'src/app/shared/data';

export const introSlider = {
    ...sliderOpt,
    nav: false,
    loop: false,
    responsive: {
        992: {
            nav: true
        }
    }
};

export const banners = [
    {
        button_title: 'Explore Now',
        button_link: 'product/search/images?searchText=indian%20politics&category=editorial&internationalCollection=&page=1',
        image: 'assets/images/editorial/banner1.jpg',
        mobile_image: 'assets/images/editorial/banner1.jpg',
        position_hor: 'start',
        position_ver: 'center',
        published: '1',
        show_text: '1',
        subtitle: 'Photos of political rallies, government officials, parliamentary sessions, and election campaigns.',
        subtitle_color: '#000000',
        text_type: '0',
        title: 'Indian Politics',
        title_color: '#000000'
    },
    {
        button_title: 'Explore Now',
        button_link: 'product/search/images?searchText=indian%20celebrity&category=editorial&internationalCollection=&page=1',
        image: 'assets/images/editorial/banner2.jpg',
        mobile_image: 'assets/images/editorial/banner2.jpg',
        position_hor: 'start',
        position_ver: 'center',
        published: '1',
        show_text: '1',
        subtitle: 'Images capturing film premieres, award ceremonies, and candid moments of Indian celebrities.',
        subtitle_color: '#000000',
        text_type: '0',
        title: 'Entertainment',
        title_color: '#000000'
    },
    {
        button_title: 'Explore Now',
        button_link: 'product/search/images?searchText=Sport&category=editorial&internationalCollection=&page=1',
        image: 'assets/images/editorial/banner3.jpg',
        mobile_image: 'assets/images/editorial/banner3.jpg',
        position_hor: 'start',
        position_ver: 'center',
        published: '1',
        show_text: '1',
        subtitle: 'Shots from sporting activities, competitions, team celebrations, athletic achievements, and fan reactions during major tournaments.',
        subtitle_color: '#000000',
        text_type: '0',
        title: 'Sports',
        title_color: '#000000'
    },
    {
        button_title: 'Explore Now',
        button_link: 'product/search/images?searchText=Monument%20and%20heritage&category=editorial&internationalCollection=&page=1',
        image: 'assets/images/editorial/banner4.jpg',
        mobile_image: 'assets/images/editorial/banner4.jpg',
        position_hor: 'start',
        position_ver: 'center',
        published: '1',
        show_text: '1',
        subtitle: 'Captivating perspectives of ancient temples, and other historical landmarks.',
        subtitle_color: '#000000',
        text_type: '0',
        title: 'Monuments & Heritage Sites',
        title_color: '#000000'
    },
    {
        button_title: 'Explore Now',
        button_link: 'product/search/images?searchText=archival&category=editorial&internationalCollection=&page=1',
        image: 'assets/images/editorial/banner5.jpg',
        mobile_image: 'assets/images/editorial/banner5.jpg',
        position_hor: 'start',
        position_ver: 'center',
        published: '1',
        show_text: '1',
        subtitle: 'Step into history with our curated archival editorial collection, capturing timeless moments and stories from the past.',
        subtitle_color: '#000000',
        text_type: '0',
        title: 'Archival',
        title_color: '#000000'
    },
    {
        button_title: 'Explore Now',
        button_link: 'product/search/images?searchText=art%20event&category=editorial&internationalCollection=&page=1',
        image: 'assets/images/editorial/banner6.jpg',
        mobile_image: 'assets/images/editorial/banner6.jpg',
        position_hor: 'start',
        position_ver: 'center',
        published: '1',
        show_text: '1',
        subtitle: 'A curated editorial collection of art and events capturing creativity, culture, and timeless moments.',
        subtitle_color: '#000000',
        text_type: '0',
        title: 'Art & Events',
        title_color: '#000000'
    },
    {
        button_title: 'Explore Now',
        button_link: 'product/search/images?searchText=fashion%20model&category=editorial&internationalCollection=&page=1',
        image: 'assets/images/editorial/banner7.jpg',
        mobile_image: 'assets/images/editorial/banner7.jpg',
        position_hor: 'start',
        position_ver: 'center',
        published: '1',
        show_text: '1',
        subtitle: 'Striking visuals celebrating global fashion—runways, street style, cultural wear, and contemporary design trends.',
        subtitle_color: '#000000',
        text_type: '0',
        title: 'Fashion Portrait',
        title_color: '#000000'
    },
    {
        button_title: 'Explore Now',
        button_link: 'product/search/images?searchText=global%20news&category=editorial&internationalCollection=&page=1',
        image: 'assets/images/editorial/banner8.jpg',
        mobile_image: 'assets/images/editorial/banner8.jpg',
        position_hor: 'start',
        position_ver: 'center',
        published: '1',
        show_text: '1',
        subtitle: 'Global events captured through editorial photography that tells stories shaping our world',
        subtitle_color: '#000000',
        text_type: '0',
        title: 'Global Events',
        title_color: '#000000'
    }
];
